import React, { useEffect } from 'react';
import * as Yup from 'yup';

import { useCommon } from '../../store/CommonContext';
import { usePayment } from '../../store/PaymentContext';

import Loader from '../../components/loader/Loader';
import { FONT_FAMILY, MODAL_BORDER_RADIUS } from '../../components/constants/style-constants';
import { getChallenge } from '../../helpers/fetch-service';

import ChallengeForm from '../../components/challenge/ChallengeForm';
import { getValidationSchema, getInitialValues } from '../../helpers/form-helper';

import { useTemplate, setParameters } from '../../store/TemplateContext';

import './Challenge.css';

interface Props {}

export interface IValidationRules {
  [key: string]: {
    value: string;
    params: null | (string | ((value: string) => void))[];
  }[];
}

export interface IInitialValues {
  values: { [key: string]: string };
  validation: IValidationRules;
}

const spreedlyValidationSchema = Yup.object().shape({
  full_name: Yup.string().required('Full name is required'),
  month: Yup.string().required('Month is required'),
  year: Yup.string().required('Year is required'),
});

const spreedlyInitialValues = {
  full_name: '',
  month: '',
  year: '',
};

const Challenge: React.FC<Props> = props => {
  const {
    state: {
      configurationLoading,
      orderDataLoading,
      configuration,
      challengeTemplateLoading,
      challengeTemplate: template,
    },
    dispatch: commonDispatch,
  } = useCommon();
  const {
    state: { parameters },
    dispatch,
  } = useTemplate();
  const {
    state: { paymentLoading },
  } = usePayment();

  useEffect(() => {
    getChallenge(commonDispatch);
  }, []);

  useEffect(() => {
    setParameters(dispatch, template?.parameters || {});
  }, [
    template?.parameters?.CureType,
    template?.parameters?.PaymentInstrumentToken,
    template?.parameters?.CardBrand,
    template?.parameters?.CardLast4Digits,
    template?.parameters?.TokenField,
    template?.parameters?.FirstNameField,
    template?.parameters?.AcsURL,
    template?.parameters?.EncodedCReq,
    template?.parameters?.ThreeDSSessionData,
    template?.parameters?.Token,
  ]);

  // useEffect(() => {
  //   if (configuration?.ConsentFlowConfiguration === 1 && challengeTemplate?.parameters?.Redirect) {
  //     const challengeButton = document.getElementById('ui-widget-challenge-button');
  //
  //     if (challengeButton) {
  //       const text = challengeButton.innerText;
  //       let counter = 10;
  //       const interval = setInterval(() => {
  //         if (counter === 0) {
  //           clearInterval(interval);
  //           if (challengeTemplate?.parameters?.Redirect === 'Approve') {
  //             redirectToSuccess();
  //           }
  //           if (challengeTemplate?.parameters?.Redirect === 'Decline') {
  //             redirectToDecline();
  //           }
  //         } else {
  //           challengeButton.innerText = `${text} (${counter})`;
  //         }
  //         counter -= 1;
  //       }, 1000);
  //     } else {
  //       setTimeout(() => {
  //         if (challengeTemplate?.parameters?.Redirect === 'Approve') {
  //           redirectToSuccess();
  //         }
  //         if (challengeTemplate?.parameters?.Redirect === 'Decline') {
  //           redirectToDecline();
  //         }
  //       }, 5000);
  //     }
  //   }
  // }, [configuration?.ConsentFlowConfiguration, challengeTemplate?.parameters?.Redirect]);

  if (
    // checkIfPlaidTemplate(template?.challenge) ||
    configurationLoading ||
    challengeTemplateLoading ||
    orderDataLoading ||
    paymentLoading ||
    !template?.challenge
  ) {
    return <Loader />;
  }

  // if (parameters?.AcsURL) {
  //   return <Tokenex3DS />;
  // }

  const initialValues = getInitialValues(
    { values: {}, validation: {} },
    template?.challenge,
    parameters.CureType === 'NewCard',
  );

  const getSpreedlyInitialValues = (): { [key: string]: string } => {
    const values = { ...spreedlyInitialValues };

    if (template?.parameters?.ExpirationMonth) {
      values.month = template?.parameters?.ExpirationMonth;
    }

    if (template?.parameters?.ExpirationYear) {
      values.year = template?.parameters?.ExpirationYear;
    }

    if (template?.parameters?.HolderName) {
      values.full_name = template?.parameters?.HolderName;
    }

    return values;
  };

  return (
    <div
      className="ui-widget-challenge"
      style={{
        ...(configuration?.fontFamily && { fontFamily: configuration.fontFamily as string }),
        ...(configuration?.modalCornersRadius && { borderRadius: configuration.modalCornersRadius as string }),
      }}
    >
      <ChallengeForm
        isCard={parameters.CureType === 'NewCard'}
        template={template?.challenge}
        initialValues={initialValues.values}
        validationSchema={getValidationSchema(initialValues.validation)}
        spreedlyValidationSchema={spreedlyValidationSchema}
        spreedlyInitialValues={getSpreedlyInitialValues()}
      />
    </div>
  );
};

export default Challenge;
